import { useAppStore } from "@/store/app";
import { storeToRefs } from "pinia";
import { CLIENT_PERMISSIONS_TO_ROLES } from "@lib/constants/advisor";

export default defineNuxtPlugin(() => {
  const { user } = storeToRefs(useAppStore());
  const hasPermission = (permission: string) => {
    const userRole = user.value?.user_type;
    if (!userRole) {
      return false;
    }
    return (CLIENT_PERMISSIONS_TO_ROLES[permission] || []).includes(userRole);
  };

  return {
    provide: {
      userRole: {
        hasPermission,
      },
    },
  };
});
